export class RegionReference {
  id: number;
  regionID: number;
  userID: number;
}
